var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "unsyncedApps",
    attrs: {
      id: "unsynced-apps-modal",
      "modal-dialog-scrollable": false,
      "footer-close-button": false,
      "modal-dialog-size": "md",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("application-reports.unsyncedApplications.title")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("application-reports.unsyncedApplications.message", {
                    unsyncedApps: _vm.nrOfUnsyncedApps,
                  })
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", {
              attrs: {
                text: _vm.$t(
                  "application-reports.unsyncedApplications.confirmBtn"
                ),
              },
              on: { click: _vm.handleHide },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }